/**
 * 新手指引tooltip
 */
import HBIcon from "@/components/HBIcon";
import { Button, Tooltip } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";

/**
 * @param {{
 *   children: ReactDOM;
 *     onClose: Function;
 *     title?: string;
 *     content?: string;
 *     initType?: "WECHAT" | "WEIBO" | "QQ" | "EMAIL" | "PHONE" | "PASSWORD";
 *     width?: number,
 *     hideAction?: boolean;
 *     actionText?: string;
 *     onAction?: Function;
 * } & import("antd").TooltipProps} props
 * @returns {JSX.Element}
 */
export default function GuideTooltip({
  children,
  onClose,
  title,
  content,
  overlayClassName,
  width,
  hideAction,
  actionText,
  onAction,
  ...rest
}) {
  return (
    <Tooltip
      color="#298DFF"
      overlayClassName={classNames(styles.tooltip, overlayClassName)}
      getPopupContainer={(triggerNode) => triggerNode}
      {...rest}
      title={
        <div style={{ width }}>
          {title && <div className={styles.title}>{title}</div>}
          {content && <div className={styles.content}>{content}</div>}
          <HBIcon className={styles.icon} type="ic_close" onClick={onClose} />

          {!hideAction && (
            <div className={styles.actions}>
              <Button size={"small"} type={"text"} onClick={onAction}>
                {actionText || "我知道了"}
              </Button>
            </div>
          )}
        </div>
      }
    >
      {children}
    </Tooltip>
  );
}
